import menu_permission from '../../middleware/menu_permission';

const routes = [
  {
    // path: '/user/dashboard',
    path: '/user',
    component: () => import('../Seller/Dashboard/userdashboard'),
    name: 'userdashboard',
  },
  {
    path: '/user/profile',
    component: () => import('../Seller/SellerProfile/EditProfile'),
    name: 'profile',
  },
  {
    path: '/user/portfolio/preview',
    // component: () => import('../Seller/SellerProfile/RightBar/UserPortfolio/previewPortfolio'),
    component: () => import('../templates/previewPortfolio'),
    name: 'PreviewPortfolio',
  },
  // Component Routes for Mail or Messages
  {
    path: '/user/seller_messages',
    component: () => import('../Seller/MyMessages/messagePage'),
    name: 'MessagePage',
  },
  {
    path: '/user/messages',
    component: () => import('../Seller/MyMessages/messages'),
    name: 'Messages',
  },
  {
    path: '/user/reply',
    component: () => import('../Seller/MyMessages/reply'),
    name: 'Reply',
  },

  {
    path: '/user/sent_messages',
    component: () => import('../Seller/MyMessages/sendMessage'),
    name: 'sent_messages',
  },

  {
    path: '/user/addProposal',
    component: () => import('../Seller/BecomeSeller/editProposal'),
    name: 'becomeSeller',
    meta: {
      permission: 'zoopbuy_freelancer.create',
      middleware: [menu_permission],
    },
  },
  {
    path: '/user/proposal',
    component: () => import('../Seller/BecomeSeller/DisplayProposal'),
    name: 'proposal',
    meta: {
      permission: 'zoopbuy_freelancer.view',
      middleware: [menu_permission],
    },
  },
  {
    path: '/user/proposal/edit:id/:userId',
    component: () => import('../../components/Seller/BecomeSeller/editProposal'),
    name: 'EditProposal',
    meta: {
      permission: 'zoopbuy_freelancer.edit',
      middleware: [menu_permission],
    },
  },
  {
    path: '/user/Conversation',
    component: () => import('../../components/Seller/Conversations/conversations'),
    name: 'Conversation',
  },

  {
    path: '/user/project/edit:project_id',
    component: () => import('../../components/Seller/Project/projectpost'),
    name: 'EditProject',
    meta: {
      permission: 'project_client.edit',
      middleware: [menu_permission],
    },
  },
  {
    path: '/user/project/reuse:project_id',
    component: () => import('../../components/Seller/Project/projectpost'),
    name: 'ReuseProject',
    meta: {
      permission: 'project_client.edit.reuse',
      middleware: [menu_permission],
    },
  },

  //Component Routes for  MyTickets and Chats
  {
    path: '/user/my_tickets',
    component: () => import('../../components/Seller/MySupportTickets/DisplayMyTickets'),
    name: 'MyTickets',
    meta: {
      permission: 'support_user.view',
      middleware: [menu_permission],
    },
  },
  {
    path: '/user/closed_ticket/:id',
    component: () => import('../Seller/MySupportTickets/ClosedTicket'),
    name: 'ClosedTicket',
  },
  {
    path: '/user/support_chat/:id',
    component: () => import('../Seller/MySupportTickets/SupportChat'),
    name: 'SupportChat',
  },
  {
    path: '/user/sellingOrders',
    component: () => import('../../components/Seller/Orders/sellingorder'),
    name: 'SellingOrders',
    meta: {
      permission: 'sellingorder_freelancer.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/user/buyingOrders',
    component: () => import('../../components/Seller/Orders/buyingorder'),
    name: 'BuyingOrders',
    meta: {
      permission: 'zoopbuy_client.view',
      middleware: [menu_permission],
    },
  },
  {
    path: '/user/OrderDetails/:type?/:id?',
    component: () => import('../../components/Seller/Orders/orderdetail'),
    name: 'OrderDetails',
    meta: {
      permission: 'zoopbuy.view.detail',
      middleware: [menu_permission],
    },
  },
  /// projectsedit//
  // {
  //     path:'/user/project/projectseditdata',
  //     component:()=>import('../../components/Seller/Project/projectseditdata'),
  //     name : 'projectseditdata'
  // },

  /// end ////

  {
    path: '/user/contest',
    component: () => import('../../components/Seller/Project/ContestProject/contests'),
    name: 'contestProjects',
    meta: {
      permission: 'contest_freelancer.view',
      middleware: [menu_permission],
    },
  },

  {
    path: '/user/projectPost/:hireto_userid?',
    component: () => import('../../components/Seller/Project/projectpost'),
    name: 'projectPost',
    meta: {
      permission: 'project_client.create',
      middleware: [menu_permission],
    },
  },
  {
    path: '/user/projectList',
    component: () => import('../../components/Seller/Project/projectlist'),
    name: 'projectList',
    meta: {
      permission: 'project_client.view',
      middleware: [menu_permission],
    },
  },

  // {
  //     path:'/user/project',
  //     component:()=>import('../../components/Seller/Project/project'),
  //     name : 'project',
  // },
  {
    path: '/user/project/:projectname/:id?',
    component: () => import('../../components/Seller/Bid/biduser'),
    name: 'allbiddetail',
    props: true,
  },

  {
    path: '/preuser/projectsdetail/:project/:project_id?',
    component: () => import('../../components/Seller/Project/projectdetails'),
    name: 'projectsdetail',
    props: true,
  },
  {
    path: '/user/projectsubmit/:project/:project_id?',
    component: () => import('../../components/Seller/Project/projectsubmit'),
    name: 'projectsubmit',
    props: true,
  },

  {
    path: '/user/projectBid/:project/:project_id?',
    component: () => import('../../components/Seller/Project/projectsubmitbid'),
    name: 'projectsubmitbid',
    props: true,
  },
  {
    path: '/user/project/bid/edit/:project_name_id',
    component: () => import('../../components/Seller/Project/bidEditByFreelancer'),
    name: 'projectEditBid',
    // props:true
  },
  {
    path: '/user/project/hire/:projectid/:userid',
    component: () => import('../../components/Seller/Project/hireuser'),
    name: 'hireuser',
    props: true,
  },

  // {
  //     path: '/user/bidproject',
  //     component: () => import('../../components/Seller/Project/bidprojectuser'),
  //     name: 'bidderUser',
  //     props:true
  // },

  {
    path: '/user/project/preview/:projectType/:projectid',
    component: () => import('../../components/Seller/Project/projectviewpage'),
    name: 'projectspreview',
    props: true,
    meta: {
      permission: 'project_client.view.preview',
      middleware: [menu_permission],
    },
  },
  /*
{
    path: '/user/project/:project/:project_id?',
    component: () => import('../../components/Seller/Project/projectviewpage'),
    name: 'projectsviewpageconversation',
    props:true
},*/

  {
    path: '/user/browse',
    component: () => import('../../components/Seller/BrowseSeller/browse'),
    name: 'BrowseUser',
  },
  {
    path: '/user/viewProfile:id',
    component: () => import('../../components/Seller/BrowseSeller/browseProfile'),
    name: 'ViewProfile',
  },
  //Component Routes for Order Revenue
  {
    path: '/user/seller_revenue',
    component: () => import('../../components/Seller/Revenue/revenue'),
    name: 'Revenue',
    meta: {
      permission: 'seller_revenue_freelancer.view',
      middleware: [menu_permission],
    },
  },

  ///  All chat start  section ///

  {
    path: '/user/allchat',
    // component:()=>import('../../components/Seller/Chat/allchats'),
    component: () => import('../pages/templates/chatBox'),

    name: 'allchat',
    meta: {
      permission: 'message_user.view',
      middleware: [menu_permission],
    },
  },

  //// End chat system ///

  {
    path: '/user/findjob',
    component: () => import('../../components/Seller/FindJob/findwork.vue'),
    name: 'FindJob',
    meta: {
      permission: 'findproject_freelancer.view',
      middleware: [menu_permission],
    },
  },
  {
    path: '/user/project/jobdetails/:project/:projectid',
    component: () => import('../../components/FrontLayout/Project/projectfrontbid'),
    name: 'userjobdetails',
  },
  {
    path: '/project/jobdetails/:project/:projectid',
    component: () => import('../../components/FrontLayout/Project/projectfrontbid'),
    name: 'projectjobdetails',
  },

  {
    path: '/user/myhires',
    component: () => import('../../components/Seller/Talents/myhires'),
    name: 'MyHires',
  },
  {
    path: '/user/hiremilestone/:userid/:projectID?',
    component: () => import('../../components/Seller/Project/hiremilestone'),
    name: 'hiremilestone',
  },

  {
    path: '/user/notification',
    component: () => import('../../components/Seller/Notification/notification.vue'),
    name: 'notification',
  },

  // Coin Setup ///
  {
    path: '/user/coin',
    component: () => import('../../components/Seller/ZoopupCoin/coin.vue'),
    name: 'coin',
  },
  {
    path: '/user/coindetail/:type?',
    component: () => import('../../components/Seller/ZoopupCoin/coindetail.vue'),
    name: 'coindetail',
  },
  {
    //path: '/user/sendemail',
    path: '/user/sendemail/MsgId:MsgId',
    component: () => import('../../components/Seller/MyMessages/sendemail.vue'),
    name: 'sendemail',
  },
  {
    path: '/zooplancer/signup',
    component: () => import('../../components/Admin/LandingPage/zooplancerSignUp.vue'),
  },
  {
    path: '/client/signup',
    component: () => import('../../components/Admin/LandingPage/clientSignUp.vue'),
  },
];
export default routes;
